import Model from "../Model";

class UsersApp extends Model{

    buildUrl ({ param }) {
        return ['/useradmin/getalluser', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new UsersApp;